const styles =  {
  margin: '10px 0',
  width: '100%',
  '&.w50': {
    flexBasis: '50%'
  },
  '&.w50.spacing-right': {
    flexBasis: 'calc(50% - 19px)',
    '&.outlined': {
      flexBasis: 'calc(50% - 10px)'
    }
  },
  '&.small': {
    flexBasis: '30%'
  },
  '&.large': {
    flexBasis: '40%'
  },
  '&.small.spacing-right': {
    flexBasis: 'calc(30% - 19px)',
    '&.outlined': {
      flexBasis: 'calc(30% - 10px)'
    }
  },
  '&.spacing-right': {
    marginRight: '19px',
    '&.outlined': {
      marginRight: '10px'
    }
  },
  /* (When Multiple inputs only) Added to close gap between inputs when Helper Text / error message is shown to match how it works on design
  (Space between inputs is always 34px no matter if there's helper text or not) */
  '&.multiple-inputs': {
    '& .MuiFormHelperText-root': {
      marginBottom: '-23px',
      marginTop: '-1px',
      marginLeft: '14px'
    }
  }
}

export default styles
